import React from 'react';
import TA35SimulatorV3 from './components/TA35SimulatorV3';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <TA35SimulatorV3 />
    </div>
  );
}

export default App;
